package models

import androidx.compose.foundation.lazy.LazyListItemInfo
import androidx.compose.runtime.Stable

@Stable
data class UiScrollState(
    val index: Int,
    val firstItemProgress: Float
)